import { getRemoteCssUrl } from '../internal/module-federation/runtime';
import enviro from 'enviro';
export const GRANITE_REMOTE_CSS_ATTR = 'data-granite-remote-css';
const LOAD_TIMEOUT = 10000;
const loadState = {};
let activeRemoteName = null;
export function resetForTesting() {
  activeRemoteName = null;
  for (const key of Object.keys(loadState)) {
    delete loadState[key];
  }
}
function applyActiveStyles(remoteName) {
  document.head.querySelectorAll(`link[${GRANITE_REMOTE_CSS_ATTR}]`).forEach(link => {
    if (link.sheet) {
      link.sheet.disabled = link.getAttribute(GRANITE_REMOTE_CSS_ATTR) !== remoteName;
    }
  });
}
function findRemoteCssLink(remoteName) {
  return document.head.querySelector(`link[${GRANITE_REMOTE_CSS_ATTR}="${remoteName}"]`);
}
function createRemoteCssLink(remoteName) {
  const cssUrl = getRemoteCssUrl(remoteName);
  if (!cssUrl) {
    return undefined;
  }
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = cssUrl;
  link.setAttribute(GRANITE_REMOTE_CSS_ATTR, remoteName);
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
  return link;
}
export function activateRemoteCss(remoteName) {
  activeRemoteName = remoteName;
  const state = loadState[remoteName];
  if ((state === null || state === void 0 ? void 0 : state.status) === 'loaded') {
    applyActiveStyles(remoteName);
    return Promise.resolve();
  }
  if ((state === null || state === void 0 ? void 0 : state.status) === 'loading') {
    return state.promise;
  }
  if ((state === null || state === void 0 ? void 0 : state.status) === 'errored') {
    document.head.querySelectorAll(`link[${GRANITE_REMOTE_CSS_ATTR}="${remoteName}"]`).forEach(link => link.remove());
  }
  const existing = findRemoteCssLink(remoteName);
  if (existing !== null && existing !== void 0 && existing.sheet) {
    loadState[remoteName] = {
      status: 'loaded'
    };
    applyActiveStyles(remoteName);
    return Promise.resolve();
  }
  const link = existing !== null && existing !== void 0 ? existing : createRemoteCssLink(remoteName);
  if (!link) {
    return Promise.resolve();
  }
  return loadLink(link, remoteName);
}
function loadLink(link, remoteName) {
  let resolveLoad;
  const promise = new Promise(res => {
    resolveLoad = res;
  });
  loadState[remoteName] = {
    status: 'loading',
    resolve: resolveLoad,
    promise
  };
  const timeout = setTimeout(onComplete, LOAD_TIMEOUT);
  function onComplete() {
    clearTimeout(timeout);
    link.onload = null;
    link.onerror = null;
    const current = loadState[remoteName];
    if ((current === null || current === void 0 ? void 0 : current.status) !== 'loading') return;
    const {
      resolve
    } = current;
    if (link.sheet) {
      loadState[remoteName] = {
        status: 'loaded'
      };
    } else {
      loadState[remoteName] = {
        status: 'errored'
      };
      link.remove();
      if (!enviro.deployed()) {
        console.error(`Failed to load CSS for remote "${remoteName}": ${link.href}`);
      }
    }
    if (activeRemoteName === remoteName) {
      applyActiveStyles(remoteName);
    }
    resolve();
  }
  link.onload = onComplete;
  link.onerror = onComplete;
  return promise;
}